import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  cta: {
    id: 'pib_communicate_cta_3',
  },
  learnablesLabel: {
    id: 'pib_learn_immerse_words',
  },

  topic: {
    id: 'pib_communicate_title',
  },
});

export const en_us = defineMessages({
  text: {
    id: 'pib_communicate_description_en',
  },
  title: {
    id: 'pib_communicate_subtitle_en',
  },
});

export const es = defineMessages({
  text: {
    id: 'pib_communicate_description_es',
  },
  title: {
    id: 'pib_communicate_subtitle_es',
  },
});
